import React, { useEffect, useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { PackageExplorerDatesFilterModal } from '../PackageExplorerDatesFilterModal';
import { IPackageExplorerDatesFilterValueContainer } from '../../types';

interface Props {
	handleSelectDate: (value: IPackageExplorerDatesFilterValueContainer) => void;
}
export const PackageExplorerDatesFilterInput = ({ handleSelectDate }: Props): JSX.Element => {
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [valueRender, setValueRender] = useState<string>('Cualquier fecha');
	const defaultValueSelected = {
		valueType: 0,
		title: 'Cualquier fecha',
		value: { travelInMonth: 0 },
	} as IPackageExplorerDatesFilterValueContainer;
	const [valueSelected, setValueSelected] = useState<IPackageExplorerDatesFilterValueContainer>(defaultValueSelected);
	const handleClick = () => setOpenModal(true);

	const handleClose = (value: IPackageExplorerDatesFilterValueContainer) => {
		setOpenModal(false);
		setValueSelected(value);
		setValueRender(value.title);
		handleSelectDate(value);
	};

	useEffect(() => {
		handleSelectDate(defaultValueSelected);
	}, []);

	return (
		<>
			<TextField
				fullWidth={true}
				value={valueRender}
				disabled={true}
				sx={{ cursor: 'pointer' }}
				onClick={handleClick}
				InputProps={{
					startAdornment: (
						<InputAdornment position="start">
							<DateRangeIcon />
						</InputAdornment>
					),
				}}
				variant="outlined"
			/>
			{openModal && <PackageExplorerDatesFilterModal open={openModal} onClose={handleClose} value={valueSelected} />}
		</>
	);
};
